import dynamic from 'next/dynamic'

export const DynamicShoppingAgentPopover = dynamic(
  () =>
    import('@/features/shop/components/ShoppingAgent/ShoppingAgentPopover').then(
      (mod) => mod.ShoppingAgentPopover,
    ),
  { ssr: false },
)
